import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, Route, CanLoad } from '@angular/router';
import { AuthService } from './auth.service'

@Injectable()
export class AuthGuardService implements CanLoad {
  constructor(private router: Router, private authService: AuthService) {
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
    })
  };
  canLoad(route: Route): boolean {
    try {
      const currentUser = JSON.parse(localStorage.getItem('auth_app_token'))
      if (currentUser && currentUser.value)
        return true;
      else {
        this.router.navigate(['/auth/login']);
        return false;
      }
    } catch (e) {
      this.router.navigate(['/auth/login']);
      return false;
    }

  }
}
